<template>
  <div class="listregist-page">
    <navbarBox></navbarBox>
    <div class="listregist-box">
      <v-container class="box" fill-height>
        <v-row class="mb-6" justify="center" align="center">
          <v-col lg="7" md="7">
            <v-card class="mx-auto" style="width: 650px">
              <v-list-item style="background-color: #141824">
                <v-list-item-content>
                  <v-list-item-title class="headline" style="color: #ffb600"
                    >ยืนยันการสมัครใช้งาน</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-card-text style="padding-bottom: 0px">
                <v-data-table
                  :headers="headers"
                  :items="datasets"
                  hide-default-footer
                  height="550px"
                  :items-per-page="1000"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>รายชื่อสมัครใช้บริการ</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="ค้นหา"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <v-dialog
                        v-model="saveDialog"
                        persistent
                        max-width="350px"
                      >
                        <v-card>
                          <v-card-title class="headline"
                            >ยืนยันการทำรายการหรือไม่?
                          </v-card-title>
                          <v-card-text></v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="success darken-1"
                              small
                              @click="save()"
                              >ยืนยัน</v-btn
                            >
                            <v-btn
                              small
                              color="error darken-1"
                              text
                              @click="close()"
                              >ยกเลิก</v-btn
                            >

                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="viewItem(item)">
                      mdi-eye
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    พบ การสมัครใช้บริการ 0 รายการ
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col lg="5" class="text-right" style="color: black"
                >รหัสประจำตัวผู้เสียภาษี</v-col
              >
              <v-col lg="7" class="text-left">{{ viewIndex.taxid }}</v-col>
              <v-col lg="5" class="text-right" style="color: black"
                >ชื่อบริษัท/ห้างหุ้นส่วน</v-col
              >
              <v-col lg="7" class="text-left">{{
                viewIndex.company_name
              }}</v-col>
              <v-col lg="5" class="text-right" style="color: black"
                >เบอร์โทรหลัก</v-col
              >
              <v-col lg="7" class="text-left">{{ viewIndex.tel_main }}</v-col>
              <v-col lg="5" class="text-right" style="color: black"
                >ไอดีไลน์หลัก</v-col
              >
              <v-col lg="7" class="text-left">{{ viewIndex.lineid }}</v-col>
              <v-col lg="5" class="text-right" style="color: black"
                >เบอร์โทรสำรอง</v-col
              >
              <v-col lg="7" class="text-left">{{ viewIndex.tel_sub }}</v-col>
              <v-col lg="5" class="text-right" style="color: black"
                >ไอดีไลน์สำรอง</v-col
              >
              <v-col lg="7" class="text-left">{{ viewIndex.lineidsub }}</v-col>
              <v-col lg="5" class="text-right" style="color: black"
                >จังหวัดที่เลือก</v-col
              >
              <v-col lg="7" class="text-left">{{ viewIndex.province }}</v-col>
              <v-col lg="5" class="text-right" style="color: black"
                >ประเภทงานที่เลือก</v-col
              >
              <v-col lg="7" class="text-left">{{ viewIndex.type_job }}</v-col>
              <v-col lg="5" class="text-right" style="color: black"
                >ไฟล์เอกสาร</v-col
              >
              <v-col lg="7" class="text-left"
                ><a :href="viewIndex.certificate" target="_blank"
                  ><u>ภ.พ.20</u></a
                ></v-col
              >
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" small @click="confirm('A')"
            >อนุมัติ</v-btn
          >
          <v-btn small color="error darken-1" text @click="confirm('UA')"
            >ไม่อนุมัติ</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
export default {
  name: "ListRegist",
  components: { navbarBox },
  data: () => ({
    method: null,
    headers: [
      {
        text: "รหัสประจำตัวผู้เสียภาษี",
        align: "start",
        sortable: false,
        value: "taxid",
      },
      {
        text: "บริษัท/ห้างหุ้นส่วน",
        align: "start",
        sortable: false,
        value: "company_name",
      },
      {
        text: "ข้อมูล",
        align: "center",
        sortable: false,
        value: "actions",
      },
    ],
    datasets: [],
    saveDialog: false,
    search: "",
    viewIndex: {},
    dialog: false,
  }),
  mounted() {
    this.getAllRegist();
  },
  methods: {
    save() {
      if (this.method === "A") {
        this.approve();
      } else {
        this.unapprove();
      }
    },
    approve() {
      this.$axios
        .post(this.api + "/approve/regist", {
          id: this.viewIndex.id,
          company_name: this.viewIndex.company_name,
          fullname: localStorage.getItem("fullname"),
          taxid: this.viewIndex.taxid,
        })
        .then((res) => {
          if (res.data.status) {
            alert("ดำเนินการเรียบร้อยเเล้ว");
            location.reload();
          }
        });
    },
    unapprove() {
      this.$axios
        .post(this.api + "/unapprove/regist", {
          id: this.viewIndex.id,
          company_name: this.viewIndex.company_name,
          fullname: localStorage.getItem("fullname"),
          taxid: this.viewIndex.taxid,
        })
        .then((res) => {
          if (res.data.status) {
            alert("ดำเนินการเรียบร้อยเเล้ว");
            location.reload();
          }
        });
    },
    confirm(action) {
      this.method = action;
      this.saveDialog = true;
    },
    close() {
      this.dialog = false;
    },
    getAllRegist() {
      this.$axios.get(this.api + "/all/regist").then((res) => {
        if (res.data.status) {
          this.datasets = res.data.response;
        }
      });
    },
    viewItem(item) {
      this.viewIndex = Object.assign({}, item);
      this.viewIndex.certificate =
        "http://www.kmppartners.info/" +
        Object.assign({}, item).certificate.split("/html/")[1];
      this.dialog = true;
      this.$axios
        .post(this.api + "/get/name/job", {
          job_type: this.viewIndex.type_job,
        })
        .then((res) => {
          if (res.data.status) {
            let name_job = "";
            for (let index = 0; index < res.data.response.length; index++) {
              if (index === res.data.response.length - 1) {
                name_job += res.data.response[index].job_type_name;
              } else {
                name_job += res.data.response[index].job_type_name + ", ";
              }
            }
            this.viewIndex.type_job = name_job;
            this.$axios
              .post(this.api + "/get/name/province", {
                province: this.viewIndex.province,
              })
              .then((ress) => {
                if (ress.data.status) {
                  let name_province = "";
                  for (
                    let index = 0;
                    index < ress.data.response.length;
                    index++
                  ) {
                    if (index === ress.data.response.length - 1) {
                      name_province += ress.data.response[index].name_th;
                    } else {
                      name_province += ress.data.response[index].name_th + ", ";
                    }
                  }
                  this.viewIndex.province = name_province;
                }
              });
          }
        });
    },
  },
};
</script>

<style>
.listregist-page {
  height: 100%;
}
</style>
